import styled from "styled-components";
import {Link} from 'react-router-dom';

export const LinkStyle = styled(Link)`
	color: #151820;
	border-bottom: 2px solid ${props => props.theme.primaryContrast};

		&:hover {
			color: #cccccc;
			border-bottom: 2px solid #cccccc;
		}
`;

export const AnchorStyle = styled.a`
	border-bottom: 2px solid ${props => props.theme.primaryContrast};
`;